export default __webpack_public_path__ + "static/media/tngIcon.2e12f0e9.png";